@use '../../../../styles/Constants.scss' as Constants;

.lost-for-reason-modal {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;
}

.copy-convert-modal {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;

	&__info {
		padding: Constants.$val-spacing-s 0;
	}

	&__job-id {
		width: 60%;

		> input {
			margin-top: Constants.$val-spacing-s;
		}
	}
}